/* DOMNO. scratch-card popup v1: the gold foil, Klaviyo sign-up, the code, and when it shows. */
(function () {
  'use strict';
  var root = document.getElementById('dx-root');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var CFG = {
    companyId: 'STCDP5',
    listEmail: 'Xbtg9k',
    listSms: 'SdCkKR',
    codeEndpoint: 'https://spin.domno.com/code',
    revision: '2025-01-15',
    delayMs: 5000,
    snoozeDays: 5,
    revealAt: 0.5, // share of the foil scratched off before it clears itself
    variant: 'scratch_v1',
    source: 'DOMNO scratch popup v1',
    smsCountries: ['GB', 'US', 'CA', 'AU', 'NZ', 'IE']
  };

  var qs = new URLSearchParams(location.search);
  var dp = qs.get('dp');
  var DEMO = dp === 'scratch';
  var FORCE_LIVE = dp === 'scratchlive';
  var reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var state = { step: 'scratch', played: false, won: false, email: '', name: '', code: '' };
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    var wide = window.matchMedia && matchMedia('(min-width: 640px)').matches;
    var u = root.getAttribute(wide ? 'data-photo-d' : 'data-photo-m');
    if (u) { var im = new Image(); im.src = u; }
  }

  /* ---------- open, close, steps ---------- */
  var lastFocus = null;
  function open(step) {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.classList.remove('is-teaser', 'is-closing', 'is-open');
    $('[data-dx-teaser]').hidden = true;
    goto(step || (state.won ? 'form' : 'scratch'), true);
    void root.offsetWidth;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    try { document.documentElement.style.overflow = 'hidden'; } catch (e) {}
    if (!state.won) paintFoil();
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    if (state.step !== 'code') store.set('dx_snooze', String(Date.now() + CFG.snoozeDays * 864e5));
    setTimeout(function () { root.classList.remove('is-closing'); root.hidden = true; }, 340);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function goto(name, instant) {
    $$('.dx-step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; s.classList.remove('is-entering'); });
    var cur = $('.dx-step[data-step="' + name + '"]');
    state.step = name;
    $('.dx-box').scrollTop = 0;
    if (!instant && !reduced) { void cur.offsetWidth; cur.classList.add('is-entering'); }
  }

  /* ---------- the gold foil ---------- */
  var card = $('[data-dx-card]'), cv = $('[data-dx-foil]'), ctx = cv.getContext('2d');
  var painted = false, dpr = 1, last = null, moves = 0, down = false;
  function rnd(seed) { return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
  function paintFoil() {
    var go = function () {
      if (state.won || state.played) return;
      var cw = card.offsetWidth, chh = card.offsetHeight; // offset sizes ignore the deal-in animation's scale
      if (!cw) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = cv.width = Math.round(cw * dpr), h = cv.height = Math.round(chh * dpr);
      var R = rnd(11), d = dpr;
      var lin = function (stops, ang) {
        var t = ang * Math.PI / 180, r = Math.max(w, h) * .75;
        var gr = ctx.createLinearGradient(w / 2 - Math.cos(t) * r, h / 2 - Math.sin(t) * r, w / 2 + Math.cos(t) * r, h / 2 + Math.sin(t) * r);
        stops.forEach(function (x) { gr.addColorStop(x[0], x[1]); });
        return gr;
      };
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, w, h);
      // brushed gold foil, light catching across it
      ctx.fillStyle = lin([[0, '#9c7630'], [.18, '#d6b45f'], [.32, '#f6e3a1'], [.42, '#c99d47'], [.55, '#e9cf83'], [.68, '#fff1c4'], [.8, '#c7a050'], [1, '#8f6a28']], 28);
      ctx.fillRect(0, 0, w, h);
      for (var i = 0; i < 160; i++) { // fine brushing
        var y = R() * h;
        ctx.strokeStyle = 'rgba(255,248,220,' + (R() * .12).toFixed(3) + ')'; ctx.lineWidth = d * (R() * .8 + .3);
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y + (R() - .5) * d * 6); ctx.stroke();
      }
      for (i = 0; i < w * h / 70; i++) { // foil grain
        ctx.fillStyle = R() > .5 ? 'rgba(255,250,230,.10)' : 'rgba(80,55,10,.10)';
        ctx.fillRect(R() * w, R() * h, d * (R() * 1.2 + .3), d * (R() * 1.2 + .3));
      }
      // edge and inner line so it reads as a card
      ctx.lineWidth = d * 1.2; ctx.strokeStyle = 'rgba(110,80,25,.55)'; ctx.strokeRect(d * .6, d * .6, w - d * 1.2, h - d * 1.2);
      var k = d * 10; ctx.lineWidth = d; ctx.strokeStyle = 'rgba(255,240,190,.55)'; ctx.strokeRect(k, k, w - 2 * k, h - 2 * k);
      // SCRATCH HERE engraved into the foil: Montserrat 800 upright, widely spaced (Dom's pick, 16 Oct)
      var T = 'SCRATCH HERE', F = 'Montserrat, Helvetica, Arial, sans-serif', fs = w * .068, tr = .22, ws, tot;
      var fit = function () {
        ctx.font = '800 ' + fs + 'px ' + F;
        ws = T.split('').map(function (c) { return ctx.measureText(c).width; });
        tot = ws.reduce(function (x, y) { return x + y; }, 0) + tr * fs * (T.length - 1);
      };
      fit(); if (tot > w * .78) { fs *= w * .78 / tot; fit(); }
      ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
      var put = function (dx, dy) { // letter by letter, so the spacing works on every phone
        var x = w / 2 - tot / 2 + dx;
        T.split('').forEach(function (c, n) { ctx.fillText(c, x, h / 2 + dy); x += ws[n] + tr * fs; });
      };
      ctx.fillStyle = 'rgba(255,246,210,.85)'; put(d * .8, d * 1.2); // light edge below
      ctx.fillStyle = 'rgba(70,48,10,.35)'; put(-d * .6, -d * .8); // shadow edge above
      ctx.fillStyle = lin([[0, '#7a5a1f'], [.5, '#9b7430'], [1, '#6e501b']], 90); put(0, 0);
      painted = true;
      card.classList.add('is-ready');
    };
    var ready = document.fonts && document.fonts.load ? withTimeout(document.fonts.load('800 40px Montserrat'), 1500).catch(function () {}) : Promise.resolve();
    ready.then(function () { requestAnimationFrame(go); });
  }
  function pt(e) {
    var r = cv.getBoundingClientRect();
    return { x: (e.clientX - r.left) * cv.width / (r.width || 1), y: (e.clientY - r.top) * cv.height / (r.height || 1) };
  }
  function scratch(a, b) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.strokeStyle = '#000'; // must be solid or the foil only half-erases
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(38 * dpr, cv.width * .12);
    ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x + .01, b.y); ctx.stroke();
  }
  function cleared() {
    try {
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data, step = 4 * 12, n = 0, z = 0;
      for (var i = 3; i < d.length; i += step) { n++; if (d[i] < 40) z++; }
      return n ? z / n : 0;
    } catch (e) { return 1; }
  }
  function onDown(e) {
    if (state.won || !painted) return;
    e.preventDefault();
    down = true; last = pt(e);
    try { cv.setPointerCapture(e.pointerId); } catch (err) {}
    card.classList.add('is-scratching');
    if (!state.played) { state.played = true; track('Scratch Popup Played', {}); }
    scratch(last, last);
  }
  function onMove(e) {
    if (!down || state.won) return;
    e.preventDefault();
    var p = pt(e); scratch(last, p); last = p;
    if (++moves % 6 === 0) { buzz(4); if (cleared() >= CFG.revealAt) win(); }
  }
  function onUp() {
    if (!down) return;
    down = false;
    if (!state.won && cleared() >= CFG.revealAt * .8) win();
  }
  function win(byKey) {
    if (state.won) return;
    state.won = true;
    store.sset('dx_won', '1');
    down = false;
    card.classList.add('is-won', 'is-ready');
    root.classList.add('is-won');
    buzz([12, 50, 22]);
    var c = $('[data-dx-claim]'); c.removeAttribute('tabindex');
    if (byKey) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 700);
  }

  /* ---------- network ---------- */
  function kpost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CFG.companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': CFG.revision },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }
  function getCode(email, name) {
    if (DEMO) return wait(800).then(function () { return { code: 'LUCK15-DEMO42' }; });
    var ask = function (kind) {
      return fetch(CFG.codeEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, first_name: name, kind: kind, country: root.getAttribute('data-country') })
      });
    };
    // asks as 'scratch'; if the worker doesn't know that kind yet, asks as 'cards' (same 15% code)
    return withTimeout(ask('scratch').then(function (r) { return r.ok ? r : ask('cards'); })
      .then(function (r) { if (!r.ok) throw new Error('code ' + r.status); return r.json(); }), 7000);
  }
  function subscribeEmail(email, name, code) {
    if (DEMO) return Promise.resolve();
    var profile = { data: { type: 'profile', attributes: { email: email, first_name: name, properties: { popup_variant: CFG.variant, coupon: 'discount' } } } };
    var sub = { data: { type: 'subscription', attributes: { custom_source: CFG.source,
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: CFG.listEmail } } } } };
    return kpost('profiles', profile).catch(function () {}).then(function () {
      return kpost('subscriptions', sub).catch(function () { return kpost('subscriptions', sub); });
    }).then(function () {
      try { if (window.klaviyo && klaviyo.identify) klaviyo.identify({ email: email, first_name: name }); } catch (e) {}
      track('Scratch Popup Submitted', { code_shown: !!code, popup_variant: CFG.variant }, email);
    });
  }
  function subscribeSms(phone) {
    if (DEMO) return wait(600);
    var sub = { data: { type: 'subscription', attributes: { custom_source: CFG.source + ' (SMS)',
      profile: { data: { type: 'profile', attributes: { email: state.email, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: CFG.listSms } } } } };
    return kpost('subscriptions', sub).then(function () { track('Scratch Popup SMS Entered', {}, state.email); });
  }
  function track(metric, props, email) {
    if (DEMO) return;
    try { if (window.dataLayer) dataLayer.push({ event: 'dx_' + metric.toLowerCase().split(' ').join('_') }); } catch (e) {}
    var em = email || state.email;
    if (!em) return;
    kpost('events', { data: { type: 'event', attributes: { properties: props || {},
      metric: { data: { type: 'metric', attributes: { name: metric } } },
      profile: { data: { type: 'profile', attributes: { email: em } } } } } }).catch(function () {});
  }

  /* ---------- forms ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function showErr(el, msg) { el.textContent = msg; el.hidden = !msg; }
  function bad(input, on) {
    var f = input.closest('.dx-field');
    f.classList.toggle('is-bad', on);
    if (on) { f.classList.remove('is-shake'); void f.offsetWidth; f.classList.add('is-shake'); }
  }
  function loading(btn, on) { btn.disabled = on; btn.classList.toggle('is-loading', on); }

  function onEmailSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget, err = $('[data-dx-err]');
    var nameI = f.elements.first_name, mailI = f.elements.email;
    var name = (nameI.value || '').trim(), email = (mailI.value || '').trim().toLowerCase();
    bad(nameI, !name); bad(mailI, !!name && !EMAIL_RE.test(email));
    if (!name) { nameI.focus(); return showErr(err, 'We need your first name.'); }
    if (!EMAIL_RE.test(email)) { mailI.focus(); return showErr(err, "That email doesn't look right."); }
    showErr(err, '');
    var btn = f.querySelector('button[type=submit]');
    loading(btn, true);
    state.name = name; state.email = email;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    getCode(email, name).then(function (d) { if (d && d.existing) state.existing = true; return d && d.code ? d.code : ''; }, function () { return ''; })
      .then(function (code) {
        if (state.existing) { track('Scratch Popup Existing Customer', {}, email); return null; }
        state.code = code; return subscribeEmail(email, name, code).then(function () { return code; });
      })
      .then(function (code) { store.set('dx_done', '1'); if (state.existing) return showExisting(); showCode(code); applyCode(code); })
      .catch(function () {
        loading(btn, false);
        if (state.code) { store.set('dx_done', '1'); showCode(state.code); applyCode(state.code); return; }
        showErr(err, "Couldn't sign you up just then. Mind trying again?");
      });
  }
  function showExisting() {
    root.classList.add('is-existing');
    $('[data-dx-hello]').textContent = state.name ? 'Hey ' + state.name + ', good to see you' : 'Good to see you';
    $('[data-dx-hascode]').hidden = true;
    var nc = $('[data-dx-nocode]'); nc.hidden = false;
    var p = nc.querySelector('p'); if (p) p.textContent = 'Looks like you’re already part of the DOMNO. family, so this one’s for new faces. Good to see you back!';
    var big = $('.dx-big'); if (big) big.style.display = 'none';
    $('[data-dx-sms]').hidden = true;
    goto('code');
  }
  function applyCode(code) {
    if (!code) return;
    var done = function () { $('[data-dx-applied]').hidden = false; };
    if (DEMO) return setTimeout(done, 900);
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(function (r) { if (r.ok) done(); }, function () {});
  }
  function showCode(code) {
    $('[data-dx-hello]').textContent = state.name ? state.name + ", here's your 15% off" : "Here's your 15% off";
    $('[data-dx-hascode]').hidden = !code;
    $('[data-dx-nocode]').hidden = !!code;
    if (code) $('[data-dx-codetext]').textContent = code;
    var country = root.getAttribute('data-country');
    $('[data-dx-sms]').hidden = !(CFG.smsCountries.indexOf(country) > -1 || DEMO);
    var cc = { GB: '44', US: '1', CA: '1', AU: '61', NZ: '64', IE: '353' }[country];
    if (cc) { var sel = $('#dx-cc'); for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === cc) { sel.selectedIndex = i; break; } }
    goto('code');
    buzz([10, 40, 18]);
  }
  function onCopy() {
    var t = $('[data-dx-copy]'), code = $('[data-dx-codetext]').textContent, label = $('[data-dx-copied]');
    var done = function () {
      t.classList.add('is-copied'); label.textContent = 'Copied'; buzz(8);
      setTimeout(function () { t.classList.remove('is-copied'); label.textContent = 'Copy'; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else {
      var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done();
    }
  }
  function onSmsSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget, err = $('[data-dx-smserr]'), cc = f.elements.cc.value;
    var digits = (f.elements.phone.value || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
    if (digits.indexOf(cc) === 0 && digits.length > 10) digits = digits.slice(cc.length);
    var ok = digits.length >= 6 && digits.length <= 13;
    bad(f.elements.phone, !ok);
    if (!ok) return showErr(err, "That number doesn't look right.");
    showErr(err, '');
    var btn = f.querySelector('button[type=submit]');
    loading(btn, true);
    subscribeSms('+' + cc + digits).then(function () {
      $('[data-dx-sms]').hidden = true;
      $('[data-dx-entered]').hidden = false;
    }, function () {
      loading(btn, false);
      showErr(err, "Couldn't add your number just then. Mind trying again?");
    });
  }

  /* ---------- wiring ---------- */
  cv.addEventListener('pointerdown', onDown);
  cv.addEventListener('pointermove', onMove);
  cv.addEventListener('pointerup', onUp);
  cv.addEventListener('pointercancel', onUp);
  $('[data-dx-reveal]').addEventListener('click', function () { if (!state.played) { state.played = true; track('Scratch Popup Played', {}); } win(true); });
  $('[data-dx-claim]').addEventListener('click', function () { if (state.won) goto('form'); });
  $$('[data-dx-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
  $('[data-dx-form]').addEventListener('submit', onEmailSubmit);
  $('[data-dx-smsform]').addEventListener('submit', onSmsSubmit);
  $('[data-dx-copy]').addEventListener('click', onCopy);
  $('[data-dx-teaser]').addEventListener('click', function () { open(); });
  $('[data-dx-shop]').addEventListener('click', function () { document.documentElement.style.overflow = ''; });
  $$('.dx-field input').forEach(function (i) { i.addEventListener('input', function () { i.closest('.dx-field').classList.remove('is-bad'); }); });
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { if (!root.hidden && !state.played && !state.won) paintFoil(); }, 200); });
  window.__dx = { root: root, CFG: CFG, state: state, open: open, close: close, goto: goto, win: win, cleared: cleared };

  /* ---------- demo screens (?dp=scratch&dx_step=) ---------- */
  function demoJump(s) {
    if (s === 'won') { open('scratch'); win(); return; }
    if (s === 'form') { win(); open('form'); return; }
    if (s === 'code' || s === 'sent' || s === 'done') {
      win(); state.name = 'Sam'; open('form');
      showCode(s === 'sent' ? '' : 'LUCK15-DEMO42');
      if (s !== 'sent') $('[data-dx-applied]').hidden = false;
      if (s === 'done') { $('[data-dx-sms]').hidden = true; $('[data-dx-entered]').hidden = false; }
      return;
    }
    open('scratch');
  }

  /* ---------- should it show? (same rules as the wheel and cards) ---------- */
  function blocked() {
    if (root.getAttribute('data-customer') === 'true') return true;
    if (store.get('dx_done') || store.get('dc_done') || store.get('ds_done')) return true;
    var snooze = parseInt(store.get('dx_snooze') || '0', 10);
    if (snooze && Date.now() < snooze) return true;
    if (/^\/(cart|checkout|account|challenge)/.test(location.pathname)) return true;
    if (qs.get('_kx') || qs.get('utm_medium') === 'email' || qs.get('utm_medium') === 'sms') return true;
    return false;
  }
  function identified() {
    try {
      if (window.klaviyo && typeof klaviyo.isIdentified === 'function') {
        return withTimeout(Promise.resolve(klaviyo.isIdentified()), 1500).catch(function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }

  if (DEMO || FORCE_LIVE) warm();
  if (DEMO) { setTimeout(function () { demoJump(qs.get('dx_step') || 'scratch'); }, 400); return; }
  if (FORCE_LIVE) { setTimeout(function () { open('scratch'); }, 400); return; }
  if (store.sget('dx_won')) state.won = true;
  (function whenReady(fn) {
    var t0 = Date.now();
    (function check() {
      if (window.DOMNO_POPUP) return fn();
      if (Date.now() - t0 < 20000) setTimeout(check, 500);
    })();
  })(function () {
    if (window.DOMNO_POPUP === 'scratch' && !blocked()) warm();
    setTimeout(function () {
      if (window.DOMNO_POPUP !== 'scratch') return;
      if (blocked()) return;
      identified().then(function (yes) { if (!yes) open('scratch'); });
    }, Math.max(0, CFG.delayMs - (window.performance ? performance.now() : 0)));
  });
})();
